// src/lib/i18n.js
import { createContext, useContext, useState } from 'react';

const STRINGS = {
  en: {
    heroTitle: 'A safe space to talk',
    heroBody: 'Confidential support for mental health, gender-based violence, and human rights concerns. Free. Anonymous. Available now.',
    cta: 'Talk to Sauti now',
    resourcesLink: 'Find help directory',
    chatPlaceholder: 'Type here… this is a safe space',
    send: 'Send',
    resumeTitle: 'Returning to a past conversation?',
    resumePrompt: 'Enter your case reference and PIN',
    resumeButton: 'Resume',
    savePinPrompt: 'Set a 4-digit PIN so you can return to this conversation later',
    savePinButton: 'Save PIN',
    disclaimer: 'Sauti is not a replacement for emergency services. If you are in immediate physical danger, please contact local emergency services.',
  },
  sw: {
    heroTitle: 'Nafasi salama ya kuzungumza',
    heroBody: 'Msaada wa siri kuhusu afya ya akili, unyanyasaji wa kijinsia, na haki za binadamu. Bila malipo. Bila jina. Inapatikana sasa.',
    cta: 'Ongea na Sauti sasa',
    resourcesLink: 'Tafuta orodha ya usaidizi',
    chatPlaceholder: 'Andika hapa… hii ni nafasi salama',
    send: 'Tuma',
    resumeTitle: 'Unarudi kwenye mazungumzo ya awali?',
    resumePrompt: 'Weka nambari ya kesi yako na PIN',
    resumeButton: 'Endelea',
    savePinButton: 'Hifadhi PIN',
    savePinPrompt: 'Weka PIN ya nambari 4 ili uweze kurudi kwenye mazungumzo haya baadaye',
    disclaimer: 'Sauti si mbadala wa huduma za dharura. Kama uko katika hatari ya haraka, tafadhali wasiliana na huduma za dharura za eneo lako.',
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('sauti_lang') ?? 'en');
  const setLanguage = (l) => { setLang(l); localStorage.setItem('sauti_lang', l); };
  return <LangContext.Provider value={{ lang, setLanguage, t: STRINGS[lang] }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside LangProvider');
  return ctx;
}
